// الحاسوب: تُفتح نافذة التقرير لحظة الضغط (قبل أي await) لتجنّب حاجب النوافذ،
// وعلى الجوال/تطبيق الهاتف لا نافذة منبثقة إطلاقاً — نفتح صفحة التقرير العامة بنفس التصميم.
import { shareReport, updateShareHtml } from "../../api/reportShare";
import { attachPdfHtml } from "../../api/reportTicket";
import { isMobileReport, openMobileReport } from "./openMobileReport";

const MOBILE = "mobile";

export const preopenWindow = () => (isMobileReport() ? MOBILE : window.open("", "_blank"));

export const closeWindow = (win) => {
  try {
    if (win && win !== MOBILE) win.close();
  } catch {
    /* نافذة مُغلقة أو مسار الجوال */
  }
};

export const openSharedReportWindow = ({
  title, build, meta = null, win = null, ticket = null, pdfUrl = null,
  ticketPromise = null, opts = null, fileName = "report", lang = "ar",
}) => {
  if (win === MOBILE || isMobileReport()) {
    openMobileReport({ title, build, meta, ticket, pdfUrl, ticketPromise, fileName, lang });
    return true;
  }
  const target = win || window.open("", "_blank");
  if (!target) return false;
  const write = (html) => {
    target.document.open();
    target.document.write(html);
    target.document.close();
  };
  // نرسم التقرير فوراً، ثم نُثريه برابط المشاركة وزر PDF في الخلفية (كتابة إضافية واحدة عند الجهوزية).
  write(build(null));
  Promise.all([
    shareReport(title, "", meta).catch(() => null),
    ticketPromise ? ticketPromise.catch(() => null) : Promise.resolve(null),
  ]).then(([share, tkt]) => {
    if (tkt?.pdf_url && opts) opts.pdfUrl = tkt.pdf_url;
    const tk = tkt?.ticket || ticket;
    const html = build(share);
    write(html);
    if (tk) attachPdfHtml(tk, html).catch(() => {});
    if (share?.token) updateShareHtml(share.token, html).catch(() => {});
  });
  return true;
};
